import React from 'react';
import ReactDOM from 'react-dom';
// import posed from 'react-pose';
import './index.css';
import App from './App';
import Paserg from './pages/Paserg'
// import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

ReactDOM.render(
  (
    <BrowserRouter>
      <Switch>
        <Route path="/paserg" component={Paserg} />
        <Route component={App} />
      </Switch>
    </BrowserRouter>
  )
  , document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js